import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Contract } from "@/types/contract";

interface DueDiligenceProps {
  contract: Contract;
}

export function DueDiligence({ contract }: DueDiligenceProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Due Diligence Information</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {contract.buyer_payment_history_summary && (
          <div>
            <span className="font-medium">Payment History Summary:</span>
            <p className="whitespace-pre-line">{contract.buyer_payment_history_summary}</p>
          </div>
        )}
        
        {contract.buyer_credit_score_summary && (
          <div>
            <span className="font-medium">Credit Score Summary:</span>
            <p className="whitespace-pre-line">{contract.buyer_credit_score_summary}</p>
          </div>
        )}
        
        {contract.collateral_details && (
          <div>
            <span className="font-medium">Collateral Details:</span>
            <p className="whitespace-pre-line">{contract.collateral_details}</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
}